import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import Select, { SelectChangeEvent } from "@mui/material/Select"
import OutlinedInput from "@mui/material/OutlinedInput"
import MenuItem from "@mui/material/MenuItem"
import { makeStyles } from "tss-react/mui"
import { LocalizedEnum, LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { ResourceType } from "../../../../../serviceCenter/admin/organization/resources/resourcesTypes"
import { iterateStringEnum } from "../../../../../../lib/enums"
import { useAppLocalization } from "../../../../../localization/components/AppLocalizationProvider"

type ResourceTypeFilterProps = Readonly<{
    value: ResourceType[]
    onChange: (event: SelectChangeEvent<ResourceType[]>) => void
}>

const useStyles = makeStyles()(() => ({
    input: {
        width: "10rem",
        minWidth: "10rem",
        ".MuiSelect-select": {
            padding: "0.5rem 1rem",
        },
        "& .MuiFormLabel-root": {
            top: "-0.5rem",
            "&.MuiInputLabel-shrink": {
                top: 0,
            },
        },
    },
}))

const selectItems = [...iterateStringEnum(ResourceType)]

export function ResourceTypeFilter({ value, onChange }: ResourceTypeFilterProps) {
    const { classes } = useStyles()
    const { l10n } = useAppLocalization()

    const getSelectLabel = (selected: ResourceType[]) =>
        selected.length === selectItems.length
            ? l10n.getString("table-select-resource-type-filter-by-all")
            : selected
                  .map((item) => l10n.getStringForEnum("table-select-resource-type-filter-by", item, item))
                  .join(", ")

    return (
        <FormControl className={classes.input}>
            <LocalizedStrict id="table-select-resource-type-filter-by-label">
                <InputLabel id="table-select-filter-by-resource-type">Resource type</InputLabel>
            </LocalizedStrict>
            <Select
                labelId="table-select-filter-by-resource-type"
                id="multiple-checkbox-resource-type"
                value={value}
                multiple
                onChange={onChange}
                renderValue={getSelectLabel}
                input={<OutlinedInput label="Resource types" />}
                MenuProps={{ PaperProps: { style: { maxHeight: 300 } } }}
            >
                {selectItems.map((value) => (
                    <MenuItem key={value} value={value}>
                        <LocalizedEnum base="table-select-resource-type-filter-by" enumValue={value}>
                            <span>{value}</span>
                        </LocalizedEnum>
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    )
}
